// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"24174b9f","190":"0c7ca241","313":"57c07c81","506":"686d3e61","787":"7717a6bb","995":"3edf03a8"}[chunkId] + ".chunk.js";
};